import { CSSProperties, useEffect, useState } from "react";
import { ChildProps_logistica_GUIA_PROFORMAviewModel } from "../ContentGuia";
import { RootState, useAppDispatch } from "../../../../redux/store";
import { obtenerRangosSeguroPorDefecto } from "../../../../redux/actions/actionsCrear";
import { useSelector } from "react-redux";
import { BigDecimal } from "@pcgerente-node/pcg-comun";
import { esDinero, esRangoGuiaConComa} from "../../../../Utils/regex";

export const StyleProps2: CSSProperties = {
    backgroundColor: "#d9d9f3",
    border: "1px solid #304aca",
    margin: "auto",
    paddingLeft: "5px"
};

const Seguro_Documentos: React.FC<ChildProps_logistica_GUIA_PROFORMAviewModel> = ({guia,setGuia, vm}) => {

    const dispatch = useAppDispatch()
    const rangosSegurosStore = useSelector((state: RootState) => state.crear.rangosSegurosPorDefecto)
    const contenidoGuiaStore = useSelector((state: RootState) => state.crear.ContenidoGuia)


    const [porcentajeSeguro, setPorcentajeSeguro] = useState("0")
    useEffect(() => {
        dispatch(obtenerRangosSeguroPorDefecto())
    },[])
    return( 
    <div className="col-xl-6 invoice-address-client">
        <div className="form-group row d-flex align-items-center m-0">
            <label
            htmlFor="name"
            className="col-sm-3 col-form-label"
            style={{textAlign: "center", paddingRight:"1rem"}}
            >
            Documentos Relacionados:
            </label>
            <div className="col-sm-6">
            <input
                type="text"
                className="form-control-plaintext"
                style={StyleProps2}
                value={guia.documentosRelacionados} 
                onChange={(e) => handleInfo("documentosRelacionados", e.target.value)}
                placeholder = "  ######"
            />
        </div>
        <div className="form-group row d-flex  align-items-center">
            <label
            htmlFor="name"
            className="col-sm-3 col-form-label"
            style={{textAlign: "center", marginRight:"1rem"}}
            >
            Valor Declarado:
            </label>
            <div className="col-sm-5">
            <input
                type="text"
                className="form-control-plaintext"
                style={StyleProps2}
                value={guia.valorDeclaradoString||""} 
                placeholder ="Ingrese un valor"
                onChange={(e) => handleInfo("valorDeclaradoString", e.target.value)}
            />
            </div>
            <button 
            style={{margin: "0 auto"}}
            className="btn btn-primary mt-1"
            disabled={contenidoGuiaStore.info.length === 0 || rangosSegurosStore.info.length === 0}
            onClick={() => handleSeguro()}
            >Calcular Seguro</button>
        </div>
        <div className="form-group row d-flex  align-items-center ml-4">
            {porcentajeSeguro?
                <label className=" p-0">{`Porcentaje Aplicado: %${porcentajeSeguro}`}</label>
                :<></>
            }
        </div>
      
      </div>
    </div>
)
function handleInfo(campo: "valorDeclaradoString"|"documentosRelacionados", value: string){
    if(campo === "valorDeclaradoString" && (esDinero(value)|| value === "")){
        setGuia({
            ...guia,
            valorDeclaradoString: value,
            valorDeclarado: new BigDecimal(value||0)
        })
    }else if(value === "" || esRangoGuiaConComa(value)){
        setGuia({
            ...guia,
            documentosRelacionados: value
        })
    }
}

function handleSeguro(){
    if(contenidoGuiaStore.loading === false && rangosSegurosStore.loading === false){
        const seguroItem = contenidoGuiaStore.info.find(el => el.descripcion === '*SEGURO*')
        if( seguroItem){
            const porcentajeSeguro = vm.AgregarSeguro(seguroItem,guia,setGuia,rangosSegurosStore.info)?.toString()||"0" 
            setPorcentajeSeguro(porcentajeSeguro)
        }
    }

}
}

export default Seguro_Documentos;